import { render, staticRenderFns } from "./stepView.vue?vue&type=template&id=6b364e00&scoped=true"
import script from "./stepView.vue?vue&type=script&lang=js"
export * from "./stepView.vue?vue&type=script&lang=js"
import style0 from "./stepView.vue?vue&type=style&index=0&id=6b364e00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b364e00",
  null
  
)

export default component.exports